import React from 'react';

const Row = ({children, className = '', onClick = () => {}, style}) => (
    <div className={'row ' + className} onClick={onClick} {...{style}}>
        {children}
    </div>
);

export default Row;